import EfSpec from '@elem/ui/ef-spec';
import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { E_DATA } from './common';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import { getDownloadInfo } from '@/service';
import EfLink from '@elem/ui/ef-link';
import { LearnMoreList } from '../../common';

export default function E() {
    const { locale = 'us' } = useRouter();
    const [list, setList] = useState<{ fileUrl: string; title: string; poster?: string }[]>([]);
    const getVideoList = async () => {
        const res = await getDownloadInfo({
            size: 4,
            classify: 'VIDEO_COURSE',
        });
        setList(res?.data?.content ?? []);
    };
    useEffect(() => {
        getVideoList();
    }, []);

    const [currentVideo, setCurrentVideo] = useState({
        isShow: false,
        videoUrl: '',
    });
    const scrollTop = useRef(0);
    const closeVideo = () => {
        setCurrentVideo({ videoUrl: '', isShow: false });
        setTimeout(() => {
            window.scrollTo({ top: scrollTop.current, behavior: 'instant' });
        }, 0);
    };

    const { moduleTitle } = (E_DATA[locale] || E_DATA['us']) ?? {};

    return (
        <>
            <div className={`support-module ${css['Support']}`}>
                <EfSpec />
                <div className="support-title">{moduleTitle}</div>
                <Swiper className="F-video-list" slidesPerView={'auto'} spaceBetween={16}>
                    {list.map((item, idx) => (
                        <SwiperSlide className="F-video-item" key={idx}>
                            <div
                                className="F-video"
                                data-url={generatorPlayUrl(item.fileUrl).url}
                                data-is-youtube={generatorPlayUrl(item.fileUrl).isYouTubeVideo}
                                onClick={() => {
                                    scrollTop.current = document.documentElement.scrollTop || document.body.scrollTop;
                                    setCurrentVideo({ videoUrl: generatorPlayUrl(item.fileUrl).url, isShow: true });
                                }}
                            >
                                <EfImg pc={item.poster || generatorPlayUrl(item.fileUrl)?.imageUrl || '/img/search/error.png'} />
                                <div className="play">
                                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1731985756287/play.svg" />
                                </div>
                            </div>
                            <div className="F-video-title">{item.title}</div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <EfLink
                    className="support-link support-more"
                    href={`support/videos`}
                    dataLayer={[
                        {
                            event: 'uaEvent',
                            event_name: 'view_more',
                            list_name: moduleTitle,
                            button_name: LearnMoreList[locale],
                        },
                    ]}
                >
                    {`${LearnMoreList[locale]} >`}
                </EfLink>
            </div>

            {/* 视频预览 */}
            <YouTubeVideoPlayer floatVideo={currentVideo.isShow} setFloatVideo={closeVideo} videoSrc={`${currentVideo.videoUrl}?autoplay=1`} />
        </>
    );
}
